import React, { useContext } from 'react';
import Image from 'next/image';
import { i18nContext } from '@/components/pages/assessments/context/i18n.context';
import { stepContext } from '@/components/pages/assessments/context/step.context';
import { displayContext } from '@/components/pages/assessments/context/display.context';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import AssessmentStart from './AssessmentStart';

const AssessmentIntro = ({ handleNext }) => {
  const { xt } = useContext(i18nContext);
  const { assessment, metadata } = useContext(stepContext);
  const { css } = useContext(displayContext);

  return (
    <>
      <Row className={css('assessment-intro')}>
        <Col>
          <Row className={css('assessment-body')}>
            <Col>
              <Row className={css('assessment-intro-panel')}>
                {metadata.intro?.headline && (
                  <Col xs={12} className={css('assessment-intro-headline')}>
                    {xt(metadata.intro.headline)}
                  </Col>
                )}
                <Col xs={12} className={css('assessment-intro-content')}>
                  <Row>
                    {metadata.intro?.description_title && (
                      <Col xs={12} className={css('assessment-intro-title')}>
                        {xt(metadata.intro.description_title)}
                      </Col>
                    )}
                    <Col xs={12} className={css('assessment-description')} dangerouslySetInnerHTML={{ __html: assessment.description }} />
                    <Col>
                      <AssessmentStart handleNext={handleNext} />
                    </Col>
                  </Row>
                </Col>
              </Row>
              {metadata?.intro?.footer && (
                <Row className={css('assessment-intro-footer')}>
                  <Col xs={12} className={css('assessment-intro-footer-content')}>
                    <Row>
                      {metadata?.intro?.footer?.details.map((contentItem, index) => {
                        return (
                          <span key={index}>
                            {contentItem.image && (
                              <p>
                                <Image
                                  src={process.env.S3_ASSET_BUCKET + contentItem.image.url}
                                  alt={xt(contentItem.image.alt)}
                                  height={contentItem.image.size?.height}
                                  width={contentItem.image.size?.width}
                                />
                              </p>
                            )}
                            {contentItem.text && <p dangerouslySetInnerHTML={{ __html: xt(contentItem.text) }}></p>}
                          </span>
                        );
                      })}
                    </Row>
                  </Col>
                </Row>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default AssessmentIntro;
